<wtaf-loader></wtaf-loader>
<!-- changes -->
<!-- <div class="d-flex overlay " *ngIf="this.loader">
  <div class="monthlyloading">Loading&#8230;</div>
</div> -->
      <div [@routeAnimations]="o.isActivated && o.activatedRoute.routeConfig.data && o.activatedRoute.routeConfig.data.title">
        <router-outlet #o="outlet"></router-outlet>
      </div>
      
      <!-- ------------ this is a changes-------------- -->